import React, { useEffect, useState } from "react";
import "../index.css";
import { Button } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import Typography from "@material-ui/core/Typography";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { makeStyles } from "@material-ui/core/styles";
import {
  Select,
  MenuItem,
  TextField,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Radio,
  AppBar,
  ButtonGroup,
  Checkbox,
} from "@material-ui/core";
import { Link, useHistory, useLocation } from "react-router-dom";
import http from "../services/httpService";
import toast, { Toaster } from "react-hot-toast";
import {
  getDateWithoutMonthName,
  searchFilter,
  handleSort,
  getToday,
} from "../utils/varialbles";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import { beigeManagementPath } from "../utils/varialbles";
import handleValidation from "../utils/handleValidations";
import handleSubmitValidation from "../utils/handleSubmitValidation";
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    paddingTop: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  submitButton: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
  },
  select: {
    height: 36,
    minWidth: 235,
  },
  gridDevider: {
    marginTop: theme.spacing(6),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  lableColor: {
    color: "#393939",
    paddingTop: "10px",
  },
  select: {
    height: 36,
    width: 235,
  },
  mobileCode: {
    height: 36,
  },
  radio: {
    "&$checked": {
      color: "#57bf74",
    },
  },

  checked: {},
}));
function AddDiscountRequest() {
  let history = useHistory();
  const [questionner, setQuestionner] = useState([]);
  const [conditionArray, setConditionArray] = useState([]);
  const [categoryDropDowm, setcategoryDropDowm] = useState([]);
  const location = useLocation();
  const classes = useStyles();

  let form = {
    name: "",
    type: "",
    amount: "",
    service_type: "",
    expiry: "",
    code: "",
    frequency: "",
  };
  let conditionForm = {
    category: "",
    condition: "",
    choice_type: null,
    choice_array: [],
    condition_array: [],
    choice: "",
    is_mandatory: false,
  };
  const validations = {
    name: {
      conditions: {
        required: true,
        maxLength: 100,
      },
      message: "This Field is required!",
      valid: true,
      changed: false,
    },
    type: {
      conditions: {
        required: true,
      },
      message: "This Field is required!",
      valid: true,
      changed: false,
    },
    amount: {
      conditions: {
        required: true,
        minValue: 10,
      },
      message: "Maximum 1000 character Allowed.!",
      valid: true,
      changed: false,
    },
    service_type: {
      conditions: {
        required: true,
      },
      message: "Maximum 1000 character Allowed.!",
      valid: true,
      changed: false,
    },
    expiry: {
      conditions: {
        // "required": false,"minDate":getToday(),"pattren":/^\d{4}-\d{2}-\d{2}$/
        required: true,
      },
      message: "Maximum 20 character Allowed.!",
      valid: true,
      changed: false,
    },
    code: {
      conditions: {
        required: true,
      },
      message: "Maximum 20 character Allowed.!",
      valid: true,
      changed: false,
    },
    frequency: {
      conditions: {
        required: true,
      },
      message: "Maximum 20 character Allowed.!",
      valid: true,
      changed: false,
    },
  };
  const [validationState, setValidationState] = useState(validations);
  const [formObject, setFromObject] = useState(form);

  let userQuestionnaire = [
    // { "lable": "Source Channel*", "filedType": "dropDown" },
    {
      lable: "Name",
      imp: true,
      filedType: "text",
      value: "name",
      display: true,
    },
    {
      lable: "Type",
      imp: true,
      filedType: "dropDown",
      value: "type",
      display: true,
    },
    {
      lable: "Service Type",
      imp: true,
      filedType: "dropDown",
      value: "service_type",
      display: true,
    },
    {
      lable: "Amount",
      imp: true,
      filedType: "number",
      value: "amount",
      display: true,
    },
    {
      lable: "Expiry Date",
      imp: true,
      filedType: "date",
      value: "expiry",
      display: true,
    },
    {
      lable: "Code",
      imp: true,
      filedType: "text",
      value: "code",
      display: true,
    },
    {
      value: "frequency",
      lable: "Frequency",
      minWidth: 150,
      imp: true,
      filedType: "dropDown",
      display: true,
    },
    // { "lable": "Condition", "imp": true, "filedType": "dropDown", "value": "category", "display": false },
  ];

  const handleCancel = () => {
    http
      .get("/event_discount_manager")
      .then((response) => {
        if (
          response.data &&
          response.data.Data &&
          Array.isArray(response.data.Data) &&
          response.data.Data.length > 0
        ) {
          setQuestionner(response.data.Data);
          let cdrop = response.data.Data.filter((obj) => {
            return obj.question === "Category";
          });
          if (cdrop && cdrop.length > 0 && cdrop[0]["options"]) {
            setcategoryDropDowm(cdrop[0]["options"]);
          }
          setConditionArray([conditionForm]);
        } else {
          // toast.error("Questioner Data Not Available for this investor..!");
          history.goBack();
        }
      })
      .catch((error) => {
        // toast.error("Questioner Data Not Available for this investor..!");
        history.goBack();
      });
  };

  let date = new Date();

  let thisyear = date.getFullYear();

  let thismonth = date.getMonth() + 1;
  let thisday = date.getDate();

  let today =
    thisyear +
    "-" +
    ("0" + thismonth).slice(-2) +
    "-" +
    ("0" + thisday).slice(-2);
  // (today);

  useEffect(() => {
    handleCancel();
  }, []);
  const handleChange = (event, boolean) => {
    let name = event.target.name;
    let value = event.target.value;
    let valid = true;
    let validStateTemp = { ...validationState };
    if (name && validStateTemp.hasOwnProperty(name)) {
      let validation = handleValidation(name, value, validStateTemp);

      setValidationState(validation.validStateTemp);
      valid = validation.valid;
    }
    if (valid || value === "" || value == 0) {
      if (boolean && value === "false") {
        value = false;
      } else if (boolean && value == "true") {
        value = true;
      }
      setFromObject({
        ...formObject,
        [event.target.name]: value,
      });
    }
  };
  const getCategoryValue = (value) => {
    let name = categoryDropDowm.filter((obj) => {
      return obj.values === value;
    });
    return name.length > 0 && name[0].name ? name[0].name : null;
  };
  const categoryMaper = {
    City: "custcity",
    Country: "custcountry",
    "Account Status": "servstatus",
    "Days to Expiry": "servexpdt",
    "Individual user": "userID",
    "Sign Up Date": "createddt",
    "Investment Name(Advice)": "asset_id",
    "RM Name": "empfname",
    "Last Investment Date": "invcreateddt",
    "Last Investment Request Date": "reqdate",
  };
  const conditionMaper = {
    Equals: "iexact",
    "Not Equals": "ne",
    "Less Than": "lt",
    "Greater Than": "gt",
    "Less Than or Equals to": "lte",
    "Greater Than or Equals to": "gte",
  };
  const handleSubmit = (event) => {
    let validStateTemp = { ...validationState };
    let validCount = 0;
    let finalObjet = { ...formObject };

    let validData = handleSubmitValidation(finalObjet, validStateTemp);
    validCount = validData.validCount;
    if (validCount === 0) {
      userQuestionnaire.map((obj) => {
        let filter = [];
        if (obj["filedType"] == "dropDown" && !obj["boolean"]) {
          filter = questionner.filter((question) => {
            return question.question === obj.lable;
          });
          if (filter.length > 0) {
            let value = filter[0].options.filter((option) => {
              return option.values === finalObjet[obj.value];
            });
            if (value.length > 0) {
              finalObjet[obj.value] = value[0]["name"];
            }
          }
        }

        if (obj["boolean"] && finalObjet[obj.value] != 1) {
          finalObjet[obj.value] = 0;
        }
      });
      let conditionArrayTemp = [...conditionArray];
      let finalCondition = [];
      conditionArrayTemp.map((object, index) => {
        if (
          object["category"] === "" ||
          object["condition"] === "" ||
          object["choice"] === ""
        ) {
        } else {
          let cat = getCategoryValue(object["category"]);
          let condition = object.condition_array.filter((obj) => {
            return obj.id === object["condition"];
          });
          let con =
            condition && condition.length > 0 && condition[0]["name"]
              ? condition[0]["name"]
              : null;
          let cho = null;
          if (object["choice_type"] === "Drop Down") {
            let choice = object.choice_array.filter((obj) => {
              return obj.id === object["choice"];
            });
            cho =
              choice && choice.length > 0 && choice[0]["name"]
                ? choice[0]["name"]
                : null;
          } else if (object["choice"] === 0 || object["choice"]) {
            cho = object["choice"];
          }
          if (cat && con && cho) {
            finalCondition.push({
              category: categoryMaper[cat] ? categoryMaper[cat] : cat,
              condition: conditionMaper[con] ? conditionMaper[con] : con,
              choice: cho,
              mandatory: object["is_mandatory"] ? "True" : "False",
            });
          }
        }
      });
      finalObjet["conditions"] = finalCondition;
      finalObjet["amount"] = Number(finalObjet["amount"]);
      if (finalCondition && finalCondition.length > 0) {
        http
          .post("/event_discount_manager", finalObjet)
          .then((response) => {
            if (response.data.statusCode === 0) {
              toast.success(response.data.Data);
              makeActive();
            } else {
              toast.error("Discount Request Failed..!");
            }

            // setFromObject(form)
          })
          .catch((error) => {
            // toast.error("Questioner Data Not Available for this investor..!");
          });
      } else {
        toast.error("Please select atleast one condition.!");
      }
    } else {
      setValidationState(validData.validStateTemp);
      toast.error("Please check Errors in Field level!");
    }
  };
  const makeActive = (event) => {
    history.push({
      pathname: beigeManagementPath,
      state: { tab: "Discount Manager" },
    });
  };

  const addNewCondtion = (e) => {
    e.preventDefault();
    let conditionTemp = [...conditionArray];
    conditionTemp.push(conditionForm);
    setConditionArray(conditionTemp);
  };
  const deleteConditon = (e, inx) => {
    let conditionTemp = [...conditionArray];
    conditionTemp.splice(inx, 1);
    setConditionArray(conditionTemp);
  };
  const handleCategoryChange = (e, index, fname) => {
    let conditionTemp = [...conditionArray];
    let value = e.target.value;
    if (fname) {
      conditionTemp[index][fname] = e.target.checked;
    } else {
      conditionTemp[index][e.target.name] = value;
    }
    if (value !== "" && e.target.name === "category") {
      conditionTemp[index]["condition"] = "";
      conditionTemp[index]["choice_type"] = null;
      conditionTemp[index]["choice_array"] = [];
      conditionTemp[index]["condition_array"] = [];
      conditionTemp[index]["choice"] = "";
      http.get("/dropdownquery?category_value=" + value).then((response) => {
        if (
          response.data &&
          response.data.Data &&
          Array.isArray(response.data.Data) &&
          response.data.Data.length > 0
        ) {
          if (response.data.Data[0]["Condition"]) {
            let conditionTempArray =
              response.data.Data[0]["Condition"].split(",");
            conditionTempArray = conditionTempArray.map((str, inx) => {
              return { id: inx + 1, name: str };
            });
            let choice = response.data.Data[0].Choice;
            if (choice && Array.isArray(choice) && choice.length > 0) {
              conditionTemp[index]["choice_type"] = "Drop Down";
              conditionTemp[index]["choice_array"] = choice;
            } else {
              conditionTemp[index]["choice_type"] = choice ? choice : null;
            }
            conditionTemp[index]["condition_array"] = conditionTempArray;
          }
          setConditionArray(conditionTemp);
        }
      });
    } else {
      setConditionArray(conditionTemp);
    }
  };
  return (
    <Grid container component="main">
      <AppBar
        position="static"
        style={{ marginBottom: 5, paddingTop: 3, paddingBottom: 3 }}
        className={classes.paper}
      >
        <Grid container component="main">
          <Grid item xs={6} sm={6} md={6}>
            <ButtonGroup>
              <Button
                variant="outlined"
                color="default"
                style={{ marginLeft: 10 }}
                onClick={() => makeActive()}
                name="invOverView"
                startIcon={<ArrowBackIosIcon />}
              >
                Back
              </Button>
            </ButtonGroup>
          </Grid>
        </Grid>
      </AppBar>
      <Grid item xs={false} sm={5} md={5}></Grid>
      <Grid item xs={false} sm={5} md={5}>
        <Typography color="textPrimary" variant="h5">
          Create Discount
        </Typography>
      </Grid>
      <Grid container style={{ marginTop: 50 }}>
        {userQuestionnaire.map((question) => {
          return question.display ? (
            <Grid container className={classes.paper} key={question.value}>
              <Grid item xs={false} sm={2} md={2}>
                <InputLabel
                  className={classes.lableColor}
                  id={question.lable + "label"}
                >
                  {question.lable}
                  {question.imp && (
                    <span
                      style={{
                        color: "red",
                        fontSize: "1.2rem",
                        marginLeft: "0.2rem",
                      }}
                    >
                      *
                    </span>
                  )}
                </InputLabel>
              </Grid>
              <Grid item lg={5} md={5} sm={5}>
                {question.filedType === "dropDown" ? (
                  questionner
                    .filter((obj) => {
                      return obj.question === question.lable;
                    })
                    .map((a) => {
                      return (
                        <>
                          <Select
                            displayEmpty
                            labelId={question.lable + "label"}
                            id="statusSelect"
                            variant="outlined"
                            className={classes.select}
                            onChange={handleChange}
                            value={
                              formObject[question.value]
                                ? formObject[question.value]
                                : ""
                            }
                            name={question.value}
                            style={
                              validationState.hasOwnProperty(question.value) &&
                                validationState[question.value]["changed"] &&
                                !validationState[question.value]["valid"]
                                ? { paddingBottom: 20 }
                                : {}
                            }
                            error={
                              validationState.hasOwnProperty(question.value) &&
                              validationState[question.value]["changed"] &&
                              !validationState[question.value]["valid"]
                            }
                          >
                            <MenuItem value="">Select</MenuItem>
                            {a.options.map((option) => {
                              return (
                                <MenuItem value={option.values}>
                                  {option.name}
                                </MenuItem>
                              );
                            })}
                            )
                          </Select>
                          {validationState.hasOwnProperty(question.value) &&
                            validationState[question.value]["changed"] &&
                            !validationState[question.value]["valid"] ? (
                            <div
                              style={{
                                color: "#f44336",
                                fontSize: "0.75rem",
                                margin: "3px 14px",
                              }}
                            >
                              {validationState[question.value]["message"]}
                            </div>
                          ) : null}
                        </>
                      );
                    })
                ) : question.filedType === "radio" ? (
                  <RadioGroup
                    row
                    aria-label="position"
                    name={question.value}
                    defaultValue={true}
                    value={
                      formObject[question.value]
                        ? formObject[question.value]
                        : true
                    }
                    onChange={(e) => handleChange(e, true)}
                  >
                    {question.options.map((option) => {
                      return (
                        <FormControlLabel
                          control={
                            <Radio
                              classes={{
                                root: classes.radio,
                                checked: classes.checked,
                              }}
                              value={option.value}
                            />
                          }
                          label={option.label}
                          labelPlacement="end"
                        />
                      );
                    })}
                  </RadioGroup>
                ) : question.filedType === "date" ? (
                  <TextField
                    id="datePickerId"
                    label="Select Date"
                    type="date"
                    // defaultValue="07:30"
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{ inputProps: { min: today } }}
                    format="YYYY-MM-DD"
                    value={formObject[question.value]}
                    onChange={handleChange}
                    name={question.value}
                    className={classes.select}
                    style={
                      validationState.hasOwnProperty(question.value) &&
                        validationState[question.value]["changed"] &&
                        !validationState[question.value]["valid"]
                        ? { paddingBottom: 20 }
                        : {}
                    }
                    error={
                      validationState.hasOwnProperty(question.value) &&
                      validationState[question.value]["changed"] &&
                      !validationState[question.value]["valid"]
                    }
                    helperText={
                      validationState.hasOwnProperty(question.value) &&
                        validationState[question.value]["changed"] &&
                        !validationState[question.value]["valid"]
                        ? validationState[question.value]["message"]
                        : ""
                    }
                  />
                ) : question.filedType === "number" ? (
                  <TextField
                    label="Enter"
                    variant="outlined"
                    value={formObject[question.value]}
                    name={question.value}
                    onChange={handleChange}
                    className={classes.select}
                    type="number"
                    style={
                      validationState.hasOwnProperty(question.value) &&
                        validationState[question.value]["changed"] &&
                        !validationState[question.value]["valid"]
                        ? { paddingBottom: 20 }
                        : {}
                    }
                    error={
                      validationState.hasOwnProperty(question.value) &&
                      validationState[question.value]["changed"] &&
                      !validationState[question.value]["valid"]
                    }
                    helperText={
                      validationState.hasOwnProperty(question.value) &&
                        validationState[question.value]["changed"] &&
                        !validationState[question.value]["valid"]
                        ? validationState[question.value]["message"]
                        : ""
                    }
                  />
                ) : (
                  <TextField
                    label="Enter"
                    variant="outlined"
                    value={formObject[question.value]}
                    name={question.value}
                    onChange={handleChange}
                    className={classes.select}
                    style={
                      validationState.hasOwnProperty(question.value) &&
                        validationState[question.value]["changed"] &&
                        !validationState[question.value]["valid"]
                        ? { paddingBottom: 20 }
                        : {}
                    }
                    error={
                      validationState.hasOwnProperty(question.value) &&
                      validationState[question.value]["changed"] &&
                      !validationState[question.value]["valid"]
                    }
                    helperText={
                      validationState.hasOwnProperty(question.value) &&
                        validationState[question.value]["changed"] &&
                        !validationState[question.value]["valid"]
                        ? validationState[question.value]["message"]
                        : ""
                    }
                  />
                )}
              </Grid>
            </Grid>
          ) : (
            ""
          );
        })}
      </Grid>
      {conditionArray.map((obj, inx) => {
        return (
          <Grid container key={"carray" + inx} className={classes.paper}>
            <Grid item xs={12} sm={2} md={2}>
              <InputLabel className={classes.lableColor} id={"conditionlabel"}>
                {conditionArray.length > 1
                  ? "Condition " + (inx + 1)
                  : "Condition"}
                <span
                  style={{
                    color: "red",
                    fontSize: "1.2rem",
                    marginLeft: "0.2rem",
                  }}
                >
                  *
                </span>
              </InputLabel>
            </Grid>
            <Grid item xs={12} md={4} sm={6} lg={2}>
              <Select
                displayEmpty
                labelId={"carray" + inx + "label"}
                id="statusSelect"
                variant="outlined"
                className={classes.select}
                onChange={(e) => handleCategoryChange(e, inx)}
                value={obj["category"] ? obj["category"] : ""}
                name={"category"}
              >
                <MenuItem value="">Select</MenuItem>
                {categoryDropDowm.map((option, index) => {
                  return (
                    <MenuItem
                      value={option.values}
                      key={"cdropdown" + index + inx}
                    >
                      {option.name}
                    </MenuItem>
                  );
                })}
                )
              </Select>
            </Grid>
            {obj.condition_array.length > 0 ? (
              <Grid item xs={12} md={4} sm={6} lg={2}>
                <Select
                  displayEmpty
                  labelId={"condidropdown" + inx + "label"}
                  id="statusSelect"
                  variant="outlined"
                  className={classes.select}
                  onChange={(e) => handleCategoryChange(e, inx)}
                  value={obj["condition"] ? obj["condition"] : ""}
                  name={"condition"}
                >
                  <MenuItem value="">Select</MenuItem>
                  {obj.condition_array.map((option, index) => {
                    return (
                      <MenuItem
                        value={option.id}
                        key={"condidropdown" + index + inx}
                      >
                        {option.name}
                      </MenuItem>
                    );
                  })}
                  )
                </Select>
              </Grid>
            ) : (
              ""
            )}
            {obj.choice_type && obj.choice_type === "Calender Date" ? (
              <Grid item xs={12} md={4} sm={6} lg={2}>
                <TextField
                  id="datePickerId"
                  label="Select Date"
                  type="date"
                  // defaultValue="07:30"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  format="YYYY-MM-DD"
                  value={obj["choice"]}
                  onChange={(e) => handleCategoryChange(e, inx)}
                  name={"choice"}
                  className={(classes.select, "select")}
                />
              </Grid>
            ) : obj.choice_type && obj.choice_type === "TextBox" ? (
              <Grid item xs={12} md={4} sm={6} lg={2}>
                <TextField
                  label="Enter Choice"
                  variant="outlined"
                  value={obj["choice"]}
                  name={"choice"}
                  onChange={(e) => handleCategoryChange(e, inx)}
                  className={(classes.select, "select")}
                />
              </Grid>
            ) : obj.choice_type && obj.choice_type === "Number Box" ? (
              <Grid item xs={12} md={4} sm={6} lg={2}>
                <TextField
                  label="Enter Choice"
                  variant="outlined"
                  value={obj["choice"]}
                  name={"choice"}
                  onChange={(e) => handleCategoryChange(e, inx)}
                  className={(classes.select, "select")}
                  type="number"
                />
              </Grid>
            ) : obj.choice_type && obj.choice_type === "Drop Down" ? (
              <Grid item xs={12} md={4} sm={6} lg={2}>
                <Select
                  displayEmpty
                  labelId={"chice" + inx + "label"}
                  id="statusSelect"
                  variant="outlined"
                  className={(classes.select, "select")}
                  onChange={(e) => handleCategoryChange(e, inx)}
                  value={obj["choice"] ? obj["choice"] : ""}
                  name={"choice"}
                >
                  <MenuItem value="">Select</MenuItem>
                  {obj.choice_array.map((option, index) => {
                    return (
                      <MenuItem value={option.id} key={"choice" + index + inx}>
                        {option.name}
                      </MenuItem>
                    );
                  })}
                  )
                </Select>
              </Grid>
            ) : (
              ""
            )}
            {obj.choice === "" || obj.condition === "" ? (
              ""
            ) : (
              <Grid item xs={12} md={3} sm={3} lg={3}>
                <FormControlLabel
                  control={
                    <Checkbox
                      value={obj["is_mandatory"]}
                      classes={{
                        root: classes.radio,
                        checked: classes.checked,
                      }}
                      checked={obj.is_mandatory}
                      onChange={(e) =>
                        handleCategoryChange(e, inx, "is_mandatory")
                      }
                      name="is_mandatory"
                    />
                  }
                  label="Is this mandatory?"
                  labelPlacement="start"
                />
              </Grid>
            )}
            {inx > 0 ? (
              <Grid item sm={1} md={1}>
                <DeleteOutlinedIcon
                  onClick={(e) => deleteConditon(e, inx)}
                  style={{
                    cursor: "pointer",
                    marginTop: "6px",
                    backgroundColor: "#d76565",
                    color: "white",
                    borderRadius: "50%",
                  }}
                ></DeleteOutlinedIcon>
              </Grid>
            ) : (
              ""
            )}
          </Grid>
        );
      })}
      <Grid container className={classes.submitButton}>
        <Grid item xs={false} sm={2} md={2}>
          <Link onClick={addNewCondtion}>Add Condition</Link>
        </Grid>
      </Grid>
      <Grid container className={classes.submitButton}>
        <Grid item xs={false} sm={2} md={2}></Grid>
        <Grid item xs={3} sm={1} md={1}>
          {/* <Button variant="outlined" color="default" onClick={handleCancel}>Cancel</Button> */}
        </Grid>

        <Grid item xs={3} sm={1} md={1}>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            Add
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default AddDiscountRequest;
